/* jshint ignore:start */
(function($) {

  $('.homepage-carousel').slick({
    fade: true,
    autoplay: true
  });

  $('.secondary-carousel').slick({
    centerMode: true,
    infinite: true,
    slidesToShow: 1,
    variableWidth: true,
    autoplay: true
  });


  $('.js-jumplink').on('click', 'a', function(ev) {

    var url = $(this).attr('href');
    var hash = url.substring(url.indexOf('#')+1);

    if( $('#' + hash).length > 0 ) {

      $('html, body').animate({
        scrollTop: $('#' + hash).offset().top
      }, 500);

      ev.preventDefault();

    }

  });

  var accordion = (function(){

    var $accordion = $('.js-accordion');
    var $accordion_header = $accordion.find('.js-accordion-heading');

    // default settings
    var settings = {
      // animation speed
      speed: 400,
      // close all other accordion items if true
      oneOpen: false
    };

    return {
      // pass configurable object literal
      init: function($settings) {
        $accordion_header.on('click', function() {
          accordion.toggle($(this));
        });

        $.extend(settings, $settings);

        // ensure only one accordion is active if oneOpen is true
        if(settings.oneOpen && $('.js-accordion-item.active').length > 1) {
          $('.js-accordion-item.active:not(:first)').removeClass('active');
        }

        // reveal the active accordion bodies
        $('.js-accordion-item.active').find('> .js-accordion-body').show();
      },
      toggle: function($this) {

        if(settings.oneOpen && $this[0] != $this.closest('.js-accordion').find('> .js-accordion-item.active > .js-accordion-heading')[0]) {
          $this.closest('.js-accordion')
                 .find('> .js-accordion-item')
                 .removeClass('active')
                 .find('.js-accordion-body')
                 .slideUp();
        }

        // show/hide the clicked accordion item
        $this.closest('.js-accordion-item').toggleClass('active');
        $this.next().stop().slideToggle(settings.speed);
      }
    };
  })();

  accordion.init({ speed: 300, oneOpen: false });

  if ('objectFit' in document.documentElement.style === false) {
    $('html').addClass('no-objectfit');

    if( $('.secondary-carousel').length > 0 ) {

      $('.secondary-carousel img').each(function(){
        var $this = $(this);
        var src = $this.attr('src');
        $this.after('<div class="secondary-carousel__background" style="background-image: url(' + src + ')"></div>');
      });

    }

  }

})(jQuery); // Fully reference jQuery after this point.
/* jshint ignore:end */
